import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Upload,
  Row,
  Col,
  DatePicker,
  Layout,
  Typography,
  Select,
  Modal,
  Spin,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./StudentRegistrationPage.css";
import Footer from "../../CommonComponents/AdminCommonCom/Footer";
import axios from "axios";
import { BranchMaster, CheckBedsAvailability } from "../../../AllAPI/AdminAPI";
import { toast } from "react-toastify";
import hostelLogo from "../../../Assets/logo.png";
import hostelImg from "../../../Assets/logo.png";

const { Header, Content } = Layout;
const { Title } = Typography;
const { Option } = Select;
const { confirm } = Modal;

export default function StudentRegistrationPage1() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [campus, setCampus] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tempValues, setTempValues] = useState(null);
  const [loading, setLoading] = useState(false);



  // Fetch campus list
  useEffect(() => {
    axios.get(BranchMaster).then((res) => {
      setCampus(res.data);
    });
  }, []);

  // 🔹 Register Button Submit Handler
const handleSubmit = async (values) => {

   setLoading(true);

  try {
    const campusId = values.branch_id;
    const response = await axios.get(`${CheckBedsAvailability}/${campusId}`);
    const responseValue = String(response.data).trim().toUpperCase();

    if (responseValue === "AVAILABLE") {
      localStorage.setItem("studentRegData", JSON.stringify(values));
      navigate("/student/reg-TermsConditions", { state: { formData: values } });

    } else if (responseValue === "NOTAVAILABLE") {
      setTempValues(values);       // Store form data
      setIsModalOpen(true);        // Open modal

    } else if (responseValue === "NOTFOUND") {
      toast.warn("Room Not Found!");
    } else {
      toast.error("Unexpected server response.");
    }

  } catch (error) {
    console.error(error);
    toast.error("Something went wrong. Please try again.");
  } finally {
    setLoading(false); 
  }
};



  return (
    <Layout className="registration-layout">
 
      <Header
        className="registration-header"
        style={{ backgroundColor: "#235784" }}
      >
         <div className="logo-container">
          <img src={hostelLogo} alt="Logo" className="company-logo" />
          <span className="company-name">Manikbag Digambar Jain Boarding</span>
        </div>
        <div className="nav-links">
          <Button
            type="link"
            style={{border:"1px solid white",color:"white"}}
            onClick={() => navigate("/student-login")}
          >
            Login
          </Button>
        </div>
      </Header>

      {/* Main Content */}
      <Content className="registration-content">
        {loading && (
        <div className="fullpage-loader">
          <Spin size="large" />
        </div>
      )}


        <div className="registration-form-container mb-5">
          <div className="header-row">
            <h2 className="page-title">Student Registration Form</h2>
          </div>

          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            autoComplete="off"
          >
            {/* Campus Selection */}
            <Row
              gutter={[16, 16]}
              className="my-2 p-2 rounded border"
              style={{ backgroundColor: "#f2f7fdff" }}
            >
              <Col xs={24} sm={6}></Col>
              <Col xs={24} sm={12}>

                <Form.Item
                      name="branch_id"
                      rules={[{ required: true, message: "Please select branch" }]}
                    >
                      <div className="branch-image-wrapper pt-2">
                        {campus.map((item) => (
                          <div
                            key={item.branch_id}
                            className={`branch-card
                              ${form.getFieldValue("branch_id") === item.branch_id ? "selected-branch" : ""}
                              ${item.status === 2 ? "disabled-branch" : ""}
                            `}
                            onClick={() => {
                              if (item.status !== 2) {   // 🔥 Prevent click when disabled
                                form.setFieldsValue({ branch_id: item.branch_id });
                                form.submit(); 
                              }
                            }}
                          >
                            <img src={hostelImg} alt={item.branch_name} className="branch-img" />
                            <p className="branch-title">{item.branch_name}</p>
                          </div>
                        ))}
                      </div>
                    </Form.Item>
              </Col>
              <Col xs={24} sm={6}></Col>
            </Row>

            {/* Buttons */}
            <Row justify="center" gutter={16}>
              <Col>
                <Button onClick={() => navigate("/student-login")}>
                  Back to Login
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </Content>

      <Modal
        size="large"
        title="Bed Not Available"
        open={isModalOpen}
        onOk={() => {
          setIsModalOpen(false);
          navigate("/student/reg-TermsConditions", { state: { formData: tempValues } });
        }}
        onCancel={() => setIsModalOpen(false)}
        okText="Yes"
        cancelText="No"
      >
        <p>
          Hostel room beds are currently not available.  
          Would you like to be added to the waiting list?  
          Click ‘Yes’ to continue.
        </p>
      </Modal>


      <Footer />
    </Layout>
  );
}
